import { isWeb } from 'shared/src/utils';

export type SettingItemKey =
  | 'profile'
  | 'shippingAddress'
  | 'personalization'
  | 'ablyPay'
  | 'poc'
  | 'alarm'
  | 'logout';

export type SettingSectionKey = 'myInfo' | 'setting';

export type SettingItem = {
  key: SettingItemKey;
  title: string;
};

export type SettingSectionData = {
  key: SettingSectionKey;
  title: string;
  items: SettingItem[];
};

export const SETTING_SECTIONS: SettingSectionData[] = isWeb
  ? [
      {
        key: 'myInfo',
        title: '내 정보',
        items: [
          { key: 'profile', title: '회원 정보 수정' },
          { key: 'shippingAddress', title: '배송지 관리' },
        ],
      },
      {
        key: 'setting',
        title: '설정',
        items: [{ key: 'logout', title: '로그아웃' }],
      },
    ]
  : [
      {
        key: 'myInfo',
        title: '내 정보',
        items: [
          { key: 'profile', title: '회원 정보 수정' },
          { key: 'shippingAddress', title: '배송지 관리' },
          { key: 'personalization', title: '맞춤 정보' },
          { key: 'ablyPay', title: '에이블리페이 관리' },
        ],
      },
      {
        key: 'setting',
        title: '설정',
        items: [
          { key: 'poc', title: '상담 그룹 등록' },
          { key: 'alarm', title: '알림 설정' },
          { key: 'logout', title: '로그아웃' },
        ],
      },
    ];
